import { Component, Input } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getSelectedCategory } from '@app/category/reducers/category.reducer';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

@Component({
	selector: 'g-mobile-category-picker',
	templateUrl: './mobile-category-picker.component.html',
	styleUrls: ['./mobile-category-picker.component.scss'],
})
export class MobileCategoryPickerComponent {
	@Input() categories: api.CategoryDto[];
	@Input() allCategories: api.CategoryDto[];
	readonly icons = { faCaretDown };
	constructor(private readonly store: Store<RootReducer.State>) {}
	readonly currentCategory$ = this.store.select(getSelectedCategory);
}
